import { render, staticRenderFns } from "./Elemento.vue?vue&type=template&id=6b6e433e&scoped=true"
import script from "./Elemento.vue?vue&type=script&lang=js"
export * from "./Elemento.vue?vue&type=script&lang=js"
import style0 from "./Elemento.vue?vue&type=style&index=0&id=6b6e433e&prod&lang=css"
import style1 from "./Elemento.vue?vue&type=style&index=1&id=6b6e433e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6e433e",
  null
  
)

export default component.exports